import { render, staticRenderFns } from "./BaseMap.vue?vue&type=template&id=56fb72f6&scoped=true"
import script from "./BaseMap.vue?vue&type=script&lang=js"
export * from "./BaseMap.vue?vue&type=script&lang=js"
import style0 from "./BaseMap.vue?vue&type=style&index=0&id=56fb72f6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fb72f6",
  null
  
)

export default component.exports